// extracted by mini-css-extract-plugin
export default {"cardOffer":"AddProduct_cardOffer__7DMlF","btnOffer":"AddProduct_btnOffer__srRgv"};